import React from 'react'
import { Text } from 'theme-ui'

import {
  ProductInfoMediaStyled,
  ProductInfoMediaTitleStyled,
  ProductInfoMediaContentStyled,
  ProductInfoMediaBackgroundStyled,
  ProductInfoMediaIconListStyled,
  ProductInfoMediaIconListItemStyled,
  ProductInfoMediaIconContainertStyled
} from './styles'
import { ProductInfoMediaProps } from './types'
import Badge from './../../atoms/Badge'
import MediaItem from './../../molecules/MediaItem'

const ProductInfoMedia: React.FC<ProductInfoMediaProps> = ({ data }) => {
  const { title, media, iconList } = data

  return (
    <ProductInfoMediaStyled>
      <ProductInfoMediaTitleStyled>
        <Text
          as="h4"
          sx={{
            variant: 'headingRaleway8',
            fontFamily: 'secondary'
          }}
        >
          {title}
        </Text>
      </ProductInfoMediaTitleStyled>
      <ProductInfoMediaContentStyled>
        {media && (
          <ProductInfoMediaBackgroundStyled>
            <MediaItem {...{ media }} />
          </ProductInfoMediaBackgroundStyled>
        )}
        {iconList && (
          <ProductInfoMediaIconContainertStyled>
            <ProductInfoMediaIconListStyled>
              {iconList.map((el) => {
                return (
                  <ProductInfoMediaIconListItemStyled key={el.key}>
                    <Badge image={el.icon} />
                  </ProductInfoMediaIconListItemStyled>
                )
              })}
            </ProductInfoMediaIconListStyled>
          </ProductInfoMediaIconContainertStyled>
        )}
      </ProductInfoMediaContentStyled>
    </ProductInfoMediaStyled>
  )
}

export default ProductInfoMedia
